import React, { useCallback } from 'react'
import _ from 'lodash'
import { clearStepsFromIngredient, linkedIngredientSteps } from '../../utils'

const getConfirmDeleteText = (model, variationField, defaultLocale) => itemToDelete => {
  if (itemToDelete.subitem) {
    return 'Are you sure you want to delete this ingredient?'
  }
  const linkedSteps = linkedIngredientSteps(model, itemToDelete.item, variationField)
  if (linkedSteps.length) {
    return (
      <React.Fragment>
        <div>Are you sure you want to delete this ingredient?</div>
        <br></br>
        <div><span style={{ color: 'red' }}>WARNING</span>: these steps are currently using this ingredient and will be removed:</div>
        <ul>
          {
            linkedSteps.map(step => <li key={`step${step.ingredientID}`}>{step.title[defaultLocale]}</li>)
          }
        </ul>
      </React.Fragment>
    )
  } else if (itemToDelete.deleteCategory) {
    return 'Are you sure you want to delete this category?'
  } else {
    return 'Are you sure you want to delete this ingredient?'
  }
}


export default ({ onChange, model, field: variationField, selectIngredient }) => {
  const handleDeleteIngredient = useCallback(({
    item,
    index,
    subitem,
    subitemIndex,
    categoryIndex,
    deleteCategory,
  }) => {

    if (deleteCategory) {
      onChange({
        target: {
          value: model.values[variationField].sections.filter((c, index) => index !== categoryIndex),
          name: `values[${variationField}].sections`,
        },
      },
      (model, modifyUtils) => {
        modifyUtils.correctErrorsAfterDeleteItem(
          model, `values[${variationField}].sections`, categoryIndex,
        )
        const ingredients = _.get(model, `values[${variationField}].sections[${categoryIndex}].ingredients`)
        ingredients.forEach(ingredient => {
          clearStepsFromIngredient(
            model,
            ingredient, null, variationField, modifyUtils,
          )
        })
        return model
      },
      )
      selectIngredient(null)
    } else {
      const id = (subitem && subitem.ingredientID) || (item && item.ingredientID)
      let path
      if (subitem) {
        path = `values[${variationField}].sections[${categoryIndex}].ingredients[${index}].replacements`
      } else {
        path = `values[${variationField}].sections[${categoryIndex}].ingredients`
      }
      const newItems = _.get(model, path, []).filter(i => i.ingredientID !== id)
      let toSelect = null
      let indexToRemove = subitem ? subitemIndex : index
      if (subitem) {
        if (newItems.length > 0) {
          const indexToSelect = Math.min(subitemIndex, newItems.length - 1)
          toSelect = `sections[${categoryIndex}].ingredients[${index}].replacements[${indexToSelect}]`
        } else {
          toSelect = `sections[${categoryIndex}].ingredients[${index}]`
        }
      } else {
        if (newItems.length > 0) {
          const indexToSelect = Math.min(index, newItems.length - 1)
          toSelect = `sections[${categoryIndex}].ingredients[${indexToSelect}]`
        }
      }

      onChange({
        target: {
          value: newItems,
          name: path,
        },
      }, (model, modifyUtils) => clearStepsFromIngredient(
        modifyUtils.correctErrorsAfterDeleteItem(model, path, indexToRemove),
        item, subitem, variationField, modifyUtils),
      )
      selectIngredient(toSelect)
    }
  }, [model, onChange, selectIngredient, variationField])


  return  { getConfirmDeleteText, handleDeleteIngredient }
}
